import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const BannerService = {
  getdata: async () => {
    try {
      const response = await apiService.get("/home-banners");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  create: async (data) => {
    const response = await apiService.post("/home-banners", data);
    return response.data;
  },
  bulkUpdateMany: async (updateddata) => {
    const response = await apiService.put(
      `/home-banners/bulk-update`,
      updateddata
    );
    return response.data;
  },
  getdetails: async (id) => {
    const response = await apiService.get(`/home-banners/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/home-banners/${id}`);
    return response.data;
  },
};

export default BannerService;
